import { render, staticRenderFns } from "./AppRenderingPage.vue?vue&type=template&id=4b33be2c&scoped=true"
import script from "./AppRenderingPage.vue?vue&type=script&lang=js"
export * from "./AppRenderingPage.vue?vue&type=script&lang=js"
import style0 from "./AppRenderingPage.vue?vue&type=style&index=0&id=4b33be2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b33be2c",
  null
  
)

export default component.exports